/**
 * @generated SignedSource<<0661f7003accbb3ae11c104b9e1edc70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type authorCardAuthor$data = {
  readonly " $fragmentSpreads": FragmentRefs<"authorAvatarAuthor" | "authorBioAuthor" | "authorNameAuthor" | "authorSocialLinksAuthor" | "entityFollowButtonBase">;
  readonly " $fragmentType": "authorCardAuthor";
};
export type authorCardAuthor$key = {
  readonly " $data"?: authorCardAuthor$data;
  readonly " $fragmentSpreads": FragmentRefs<"authorCardAuthor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "authorCardAuthor",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorSocialLinksAuthor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorAvatarAuthor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorNameAuthor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorBioAuthor"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityFollowButtonBase"
    }
  ],
  "type": "Author",
  "abstractKey": null
};

(node as any).hash = "8e92e3d97d95d0af8487f668189bc5ac";

export default node;
